import course from '@images/learnRecord/course.png'
import ebook from '@images/learnRecord/ebook.png'
import exam from '@images/learnRecord/exam.png'
import live from '@images/learnRecord/live.png'
import map from '@images/learnRecord/map.png'
import practive from '@images/learnRecord/practice.png'
import train from '@images/learnRecord/train.png'
import video from '@images/learnRecord/video.png'
import { transform } from '@utils/intl_lang'
const type = [
  {
    id: 1,
    // '课程'
    name: 'course',
    icon: course,
    type: 'COURSE',
    typeName: 'behaviorContentDesc',
  },
  // '直播'
  {
    id: 2,
    name: 'live',
    icon: live,
    type: 'LIVE',
    typeName: 'liveName',
  },
  {
    id: 3,
    // '直播回放'
    name: 'living_replay',
    icon: live,
    type: 'LIVE_BACK',
    typeName: 'liveName',
  },
  {
    id: 4,
    // '学习地图'
    name: 'learn_map',
    icon: map,
    type: 'STUDY_MAP',
    typeName: 'behaviorContentDesc',
  },
  {
    id: 5,
    // '考试'
    name: 'exam',
    icon: exam,
    type: 'EXAM',
    typeName: 'examName',
    scoreName: 'examScore',
  },
  // '电子书'
  {
    id: 6,
    name: 'EBOOK',
    icon: ebook,
    type: 'EBOOK',
    typeName: 'courseName',
  },
  {
    id: 7,
    // '通关任务'
    name: 'customs_clearance_task',
    icon: practive,
    type: 'PRAC_TASK',
    typeName: 'itrainName',
    scoreName: 'itrainScore',
  }, // 智能陪练---通关任务
  {
    id: 8,
    // '陪练机器人'
    name: 'sparring_robot',
    icon: practive,
    type: 'PRAC_ROBOTA',
    typeName: 'itrainName',
    scoreName: 'itrainScore',
  }, // 智能陪练--陪练机器人
  {
    id: 10,
    // '面授班'
    name: 'training_class',
    icon: train,
    type: 'TRAIN_CLASS',
    typeName: 'trainClassName',
  },
  {
    id: 11,
    // '短视频'
    name: 'short_video',
    icon: video,
    type: 'SMALL_VIDEO',
    typeName: 'smallVideoName',
  },
]
const actions = (
  typeName: string,
  name: string,
  actionType: number,
  score?: any
) => {
  // 需要改进
  const actionString = [
    // `学习${typeName}「${name}」`
    { id: 1, decs: transform('learn_typeName', { typeName, name }) },
    // `分享${typeName}「${name}」`
    { id: 2, decs: transform('share_typeName', { typeName, name }) },
    // `对${typeName}「${name}」进行了评分`
    { id: 3, decs: transform('commend_typeName', { typeName, name }) },
    // `收藏${typeName}「${name}」`
    { id: 4, decs: transform('collect_typeName', { typeName, name }) },
    // `观看${typeName}「${name}」`
    { id: 5, decs: transform('look_typeName', { typeName, name }) },
    // `主持${typeName}「${name}」`
    { id: 6, decs: transform('host_typeName', { typeName, name }) },
    // `赠礼了${typeName}「${name}」`
    { id: 7, decs: transform('gift_typeName', { typeName, name }) },
    // `${typeName}「${name}」完成结业`
    { id: 8, decs: transform('completed_typeName', { typeName, name }) },
    // `闯关完成${typeName}「${name}」`
    { id: 9, decs: transform('chuangguan_typeName', { typeName, name }) },
    {
      id: 10,
      //  `参与${typeName}「${name}」${+score > 0 ? `，成绩${score}分` : ''}`
      decs: transform('participate_typeName', {
        typeName,
        name,
        score: `${+score > 0 ? transform('grades_score', { score }) : ''}`,
      }),
    },
    // `阅读${typeName}「${name}」`
    { id: 11, decs: transform('read_typeName', { typeName, name }) },
    {
      id: 12,
      // `参与${typeName}「${name}」${+score > 0 ? `，成绩${score}分` : ''}`
      decs: transform('participate_typeName', {
        typeName,
        name,
        score: `${+score > 0 ? transform('grades_score', { score }) : ''}`,
      }),
    }, // 通过(暂时作为"参与"，和10一样)
    // `评论${typeName}「${name}」`
    { id: 13, decs: transform('comment_typeName', { typeName, name }) },
    {
      id: 14,
      // `参训${typeName}「${name}」${+score > 0 ? `，成绩${score}分` : ''}`
      decs: transform('participate_in_training', {
        typeName,
        name,
        score: `${+score > 0 ? transform('grades_score', { score }) : ''}`,
      }),
    },
    // {id:15,name:'获得'}, 暂时没用到
    // {id:16,name:'兑换'}
  ]
  const result =
    actionString.filter((val: any) => val.id === actionType)[0] || {}
  return result.decs || ''
}
const names = (value: any) => {
  const typeValue: any = type.filter((item: any) => item.id === value.type)[0]
  const score = !!typeValue.scoreName ? value[typeValue.scoreName] : 0
  let result = ''
  if (
    typeValue.type === 'STUDY_MAP' &&
    (value.actionType === 1 || value.actionType === 8 || value.actionType === 9)
  ) {
    const temp = value[typeValue.typeName].split('-')
    result = `${actions(
      transform(typeValue.name),
      temp[0],
      value.actionType,
      score
    )} ${temp[1] || ''} `
  } else if (
    (typeValue.type === 'LIVE' || typeValue.type === 'LIVE_BACK') &&
    value.actionType === 7
  ) {
    result = `${actions(
      transform(typeValue.name),
      value[typeValue.typeName],
      value.actionType,
      score
    )} ${value.gitfInfo || ''}`
  } else if (
    typeValue.type === 'EXAM' ||
    typeValue.type === 'PRAC_ROBOTA' ||
    typeValue.type === 'PRAC_TASK' ||
    typeValue.type === 'EBOOK'
  ) {
    result = `${actions(
      transform(typeValue.name),
      value[typeValue.typeName],
      value.actionType,
      score
    )}`
  } else if (typeValue.type === 'SMALL_VIDEO') {
    result = `${actions(
      transform(typeValue.name),
      value.smallVideoName,
      value.actionType
    )}`
  } else {
    result = actions(
      transform(typeValue.name),
      value.behaviorContentDesc, // value[typeValue.typeName],
      value.actionType
    )
  }
  if (typeValue.type !== 'STUDY_MAP' && !!value.durationStr) {
    // `${result}，时长${value.durationStr}`
    result = transform('result_durationStr', {
      result,
      durationStr: value.durationStr,
    })
  }
  if (typeValue.type === 'TRAIN_CLASS') {
    // `参加${typeValue.name}「${value.trainClassName}」`
    result = transform('typeValue_trainClassName', {
      typeValue: transform(typeValue.name),
      trainClassName: value.trainClassName,
    })
  }
  return result
}
export { type, names }
